<style>
  .pin-input {
    padding: 10px;
      border: 1px solid #ddd;
      height: 50px;
      text-align: center;
      font-size: 30px;
  }
</style>
<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-full lg:w-5/6 xl:w-2/3">
			<vx-card>
				<div class="flex mb-8">
					<router-link :to="`/campaign/checkout/${$route.params.slug_and_id}?amount=10000`">
						<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
					</router-link>
					<strong class="text-primary"><small>Konfirmasi Pembayaran</small></strong>
				</div>

				<div class="flex justify-center mb-12">
					<img src="/assets/images/topup/confirm.svg" alt="" class="md:w-1/4 w-1/6" />
				</div>
				<section class="vx-row justify-center mb-24">
					<div class="vx-col lg:w-5/6 xl:w-2/3">
						<table class="w-full">
              <tr>
                <td class="text-left py-2">
                  <strong class="text-dark">Campaign</strong>
                </td>
                <td class="text-right"><strong class="text-dark">{{ truncateString(campaign.name, 150) }}</strong></td>
              </tr>
							<tr>
								<td class="text-left py-2">
									<strong class="text-dark">Jenis Donasi</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">Campaign</strong>
								</td>
							</tr>
							<tr>
								<td class="text-left py-2">
									<strong class="text-dark">Nominal</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">Rp {{ formatRupiah(transactionAmount) }}</strong>
								</td>
							</tr>
							<tr>
								<td class="text-left py-2">
									<strong class="text-dark">Metode Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionPayment ? transactionPayment.name : '' }}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<table class="w-full">
							<tr>
								<td class="text-left">
									<strong class="text-dark">Total Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-dark">Rp {{ formatRupiah(transactionAmount) }}</strong>
								</td>
							</tr>
						</table>
            <vs-divider class="my-4"></vs-divider>

            <!-- Detail Name -->
            <vs-collapse v-if="profile">
              <vs-collapse-item>
                <div slot="header">
                  <small>Info Donatur (opsional)</small>
                </div>
                <form>
                  <p class="mb-2"><strong>Nama</strong></p>
                  <vs-input 
                    class="w-full rounded-lg mb-4"
                    v-model="name"
                  />
                  <p class="mb-2"><strong>Email</strong></p>
                  <vs-input 
                    class="w-full rounded-lg mb-4"
                    v-model="email"
                  />
                  <p class="mb-2"><strong>No. Telepon</strong></p>
                  <vs-input 
                    class="w-full rounded-lg mb-4"
                    v-model="no_telp"
                  />
                </form>
              </vs-collapse-item>
            </vs-collapse>
            <form v-else>
              <p class="mb-2"><strong>Nama</strong></p>
              <vs-input 
                class="w-full rounded-lg mb-4"
                v-model="name"
                name="name"
                v-validate="'required'"
                :danger="errors.has('name')"
              />
              <span v-if="errors.has('name')" class="text-small text-danger">
                {{ errors.first('name') }}
              </span>
              <p class="mb-2"><strong>Email</strong></p>
              <vs-input
                class="w-full rounded-lg mb-4"
                v-model="email"
                name="email"
                v-validate="'required|email'"
                :danger="errors.has('email')"
              />
              <span v-if="errors.has('email')" class="text-small text-danger">
                {{ errors.first('email') }}
              </span>
              <p class="mb-2"><strong>No. Telepon</strong></p>
              <vs-input
                type="number"
                class="w-full rounded-lg mb-4"
                v-model="no_telp"
                name="no_telp"
                v-validate="'required|min:10|max:13'"
                :danger="errors.has('no_telp')"
              />
              <span v-if="errors.has('no_telp')" class="text-small text-danger">
                {{ errors.first('no_telp') }}
              </span>
            </form>
            <!-- / -->
            
            <!-- Doa -->
            <div class="mb-4">
              <strong class="mb-2">Doa (opsional)</strong>
              <vs-textarea class="w-full rounded-lg" v-model="doa" />
            </div>
            <!-- / -->

            <!-- Is Anonymous donatur -->
            <div class="flex items-center mb-4">
              <vs-checkbox v-model="status_hide" class="mr-3" />
              <strong>Sembunyikan nama saya</strong>
            </div>
            <!-- / -->
					</div>
				</section>

				<vs-button class="py-4 w-full" @click.prevent="validateTransaction">
					<strong class="text-white">Bayar</strong>
				</vs-button>
			</vx-card>
		</div>

    <!-- Modal Verify Pin -->
    <vs-popup 
      fullscreen 
      title="Verifikasi PIN Saldo" 
      :active.sync="popupPinSaldo">
        
        <pin-form 
          layoutClass="mx-auto w-full vx-row justify-center w-full md:w-1/2 mb-12"
          @authPin="authPin" 
        >
          <template v-slot:header>
            <h3 class="text-primary mb-6 text-center">
              <strong>
                Verifikasi PIN Saldo Anda
              </strong>
            </h3>
          </template>
        </pin-form>

    </vs-popup>
    <!-- / -->
	</section>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import { transactionStatus } from '@/assets/utils/transaction';

const dict = {
  custom: {
    name: {
      required: 'Harap masukan nama lengkap anda'
    },
    email: {
      required: 'Harap masukan email anda',
      email: 'Harap masukan email yang valid'
    },
    no_telp: {
      required: 'Harap masukan no telepon anda',
      min: 'Minimal nomer telepon 10 digit',
      max: 'Maksimal nomer telepon 13 digit'
    }
  }
};

Validator.localize('en', dict);

export default {
  components: {
    PinForm: () => import('@/views/components/PinForm.vue')
  },
  data: () => ({
    popupPinSaldo: false,
    amount: 0,
    fitur_id: 1,
    payment: {},
    jenis: [],
    name: 'Hamba Allah',
    alamat: null,
    email: null,
    no_telp: null,
    payload: {},
    status_hide: false,
    doa: null,
    campaign: {name: ''}
  }),
  computed: {
    campaignStatus () {
      return transactionStatus.find(it => it.name === 'campaign')
    },
    ...mapState('campaign', ['transactionAmount', 'transactionPayment', 'transactionTypes']),
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    authPin() {
      const isCorrect = true
      if(isCorrect) {
        this.$vs.loading()
        this.popupPinSaldo = false
        this.$store.dispatch('campaign/makeTransaction', [this.payload])
          .then(() => {
            
            this.$vs.loading.close()

            // Delete state payment and product
            this.$store.dispatch('campaign/deleteTransactionProduct')
            this.$store.dispatch('campaign/deleteTransactionPayment')
            this.$store.dispatch('campaign/deleteTransactionAmount')
            this.$store.dispatch('campaign/deleteTransactionTypes')

            setTimeout(() => {
              this.$router.push(`/campaign/${this.$route.params.id}/complete_pay`)
            }, 1000)
              
          })
          .catch(e => {
            this.$vs.loading.close()
            if (e.response) {
              console.error(e.response)
              this.$vs.notify({
                title: 'Oops',
                text: e.response.data.message,
                color: 'warning',
                position: 'top-right'
              })
            }

            return false
          })
      }
      else {
        this.$vs.notify({
          title: 'PIN Saldo Salah',
          text: '',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }
    },
    validateTransaction() {
      if( this.profile ) {
        this.postTransaction();
      }
      else {
        this.$validator.validateAll().then(res => {
          if(res) {
            this.postTransaction();
          }
        });
      }
    },
    postTransaction () {
      Object.assign(this.payment, this.transactionPayment)
      this.amount = this.transactionAmount

      let jenis_id = 1
      if(this.jenis.length > 0) {
        const jenis = this.jenis.find(it => it.name.toLowerCase() == 'campaign')

        if(jenis) {
          jenis_id = jenis.id
        }
      }

      const success_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://dev.zax.co.id',
            failed_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://dev.zax.co.id'
      const status_hide = this.status_hide ? 1 : 0

      if( this.profile ) {
        this.payload = {
          user_id: this.profile.id,
          metode_id: this.payment.id,
          jenis_id,
          fitur_id: this.fitur_id,
          jumlah_bayar: this.amount,
          success_url,
          failed_url,
          name: this.name,
          email: this.email,
          no_telp: this.no_telp,
          status_hide,
          doa: this.doa
        }
      }
      else {
        this.payload = {
          metode_id: this.payment.id,
          jenis_id,
          fitur_id: this.fitur_id,
          jumlah_bayar: this.amount,
          success_url,
          failed_url,
          name: this.name,
          email: this.email,
          no_telp: this.no_telp,
          status_hide,
          doa: this.doa
        }
      }

      if( this.$route.query.ref ) {
        this.payload.referal = this.$route.query.ref
      }

      if(this.campaign.user) {
        this.payload.mitra_id = this.campaign.user.id
      }

      // check if using saldo, show popup
      if(this.payment.code === 'saldo') {
        this.popupPinSaldo = true
      }
      else {
        this.$vs.loading()
        this.$store.dispatch('campaign/makeTransaction', [this.payload])
          .then(() => {
            this.$vs.loading.close()
            // Delete state payment and product
            this.$store.dispatch('campaign/deleteTransactionProduct')
            this.$store.dispatch('campaign/deleteTransactionPayment')
            this.$store.dispatch('campaign/deleteTransactionAmount')
            this.$store.dispatch('campaign/deleteTransactionTypes')

            this.$router.push(`/campaign/complete/${this.$route.params.slug_and_id}`);
          })
          .catch(e => {
            this.$vs.loading.close()
            if (e.response) {
              console.error(e.response)
              this.$vs.notify({
                title: 'Oops',
                text: e.response.data.message,
                color: 'warning',
                position: 'top-right'
              })
            }

            return false
          })
      }
    },
    getTypeTransaction () {
      this.$vs.loading()
      this.$store.dispatch('campaign/getTypeTransaction')
        .then(types => {
          this.$vs.loading.close()
          this.jenis = types
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)	
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  created () {
    this.checkVerifyAccount();
    if( this.transactionPayment == null ) {
      this.$router.push(`/campaign/donation-amount/${this.$route.params.slug_and_sid}`);
    }

    // get id from slug
		const arrSlug = this.$route.params.slug_and_id.split('-'),
				id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

    this.fitur_id = id;

    this.$store.dispatch('campaign/getDetail', id)
    .then(campaign => {
      Object.assign(this.campaign, campaign);
    })
    .catch(e => console.error(e));
    this.getTypeTransaction();
  }
}
</script>